export default __webpack_public_path__ + "static/media/sertifikat.815114a3.svg";